export function logout() {
  const kc = window.__keycloak;
  if (!kc) return;

  kc.logout({
    redirectUri: window.location.origin,
  });
}